import React from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from './ui/accordion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });
  const content = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#030308] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-amber-500 mb-3 block font-bold">FAQ</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-white mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Got Questions?<br /><span className="text-gradient-amber">We've Got Answers.</span>
          </h2>
          <p className="text-base text-slate-300 leading-relaxed">
            Straight answers about trademark registration, USPTO filing, pricing, and Amazon Brand Registry. No legal jargon.
          </p>
        </div>

        <div ref={content.ref} className={`max-w-3xl mx-auto scroll-fade-up scroll-delay-2 ${content.isVisible ? 'scroll-visible' : ''}`}>
          <Accordion type="single" collapsible>
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} data-testid={`faq-item-${faq.id}`} className="border-b border-white/10">
                <AccordionTrigger className="text-left text-sm font-bold text-white hover:text-amber-400 py-6 [&[data-state=open]]:text-amber-400">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
